<template>
<div class="header">
    <div class="headercontainer">
        <a href="/"><img src="../assets/logo.png"></a>
        <div class="headerRight fright">
            <router-link :to="{ path: 'main'}" class="item" :active-class="active">首页</router-link>
            <router-link :to="{ path: 'product'}" class="item" :active-class="active">产品</router-link>
            <router-link :to="{ path: 'aboutus'}" class="item" :active-class="active">关于我们</router-link>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            active: 'active'
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    position: relative;
    font-size: 14px;
    color: #333;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    left: 0;
    top: 0;
    // z-index: 1;
    width: 1120px;
    height: 70px;
    line-height: 70px;
    margin: 0 auto 0 auto;
    padding: 0 10px;
    text-align: left;
    vertical-align: middle;
    background: #fff;
    justify-content: space-between;
    // box-shadow: rgba(167, 167, 168, .5) 0px 0px 4px 2px;
    // overflow: hidden;
}

.headercontainer {
    height: 70px;
    line-height: 70px;
}

.fright {
    float: right;
}

.item {
    display: inline-block;
    box-sizing: border-box;
    height: 40px;
    line-height: 40px;
    margin: 15px 15px;
    cursor: pointer;
    font-size: 16px;
    color: #000;

    a {
        color: #000;
    }
}

.headerRight {
    box-sizing: border-box;
    padding-left: 600px;
}

.active {
    font-weight: 600;
    a {
        color: #fff;
    }
}
</style>
